module.exports = __webpack_public_path__ + "static/media/advantage@3x.a4d6cac2.png";